export default __webpack_public_path__ + "static/media/GWAS-single.df12c067.png";